/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.MileOrMeters = (function () {

    function MileOrMeters() {

        Monet.UI.Fields.Distance.apply(this, arguments);

        //Campos em miles e km devem exibir 2 casas decimais
        this.precision = 2;

        this.getValue = function () {
            if (this.input.value === "")
                this.value = "";
            else if (this.input)
                this.value = new BigInt(this.convertToMetricSystem(this.input.value)) * 1;
            return this.value;
        };

        this.setValue = function (value) {
            this.value = (value || value === "" || value === 0 ) ? value : this.value;
            this.setInputValue();
        };

        this.setInputValue = function () {
            if(this.input) {
                if (this.value)
                    this.input.value = this.convertToUserMetricSystem(this.value);
                else if (this.value === 0)
                    this.input.value = 0;
            }
        };

        this.convertToMetricSystem = function (value) {

            var valueToConvert = value || 0;
            var formatter = new Monet.Format.MILES_OR_METERS(valueToConvert);

            if (valueToConvert !== '') {
                formatter.parseFloat();
            }

            if (Monet.Session.User.unitSystem === "NON_METRIC" && valueToConvert !== "") {
                formatter.convertMilesToMeters();
            }

            return formatter.getValue();

        };

        this.convertToUserMetricSystem = function (value) {

            var valueToConvert = value || 0;
            var formatter = new Monet.Format.MILES_OR_METERS(valueToConvert);

            if (Monet.Session.User.unitSystem === "NON_METRIC" && valueToConvert !== "") {

                formatter.convertMetersToMiles();

                return formatter.setPrecision(this.precision).formatWithoutSeparatorThousands().getValue();

            } else if (typeof valueToConvert === 'string') {

                formatter.parseFloat();

            }

            return formatter.getValue();


        };

        this.createElement = function () {

            this.input = document.createElement('input');

            this.input.type = 'text';
            this.input.className = 'mileOrKmField';

            if (this.maxSize) {
                this.input.maxLength = this.maxSize;
            }

            this.rootEl.appendChild(this.input);

        };

        this.addEventListeners = function () {

            var precision;
            if (this.meta && this.meta.precision) {
                precision = this.meta.precision.substr(1);
                this.input.setAttribute('precision', precision);
            }

            if (Monet.Session.User.unitSystem === "METRIC") {
                $(this.input).on("keyup blur focus", function (e) {
                    e.preventDefault();
                    var expre = /[^0-9]/g;
                    if ($(this).val().match(expre)) {
                        $(this).val($(this).val().replace(expre, ''));
                    }
                });
            } else {
                const digitalGrouping = Monet.I18n.locale.digitalGrouping;
                const decimalSymbol = Monet.I18n.locale.decimalSymbol;
                $(this.input).maskMoney({
                    prefix: '',
                    decimal: decimalSymbol,
                    thousands: digitalGrouping,
                    allowNegative: true,
                    allowZero: true,
                    defaultZero: false,
                    allowEmpty: true,
                    precision: parseInt(precision) || parseInt(this.precision)
                });

                $(this.input).on("keydown", function (e) {
                    const floatValue = parseFloat($(this).val().toString().replace(digitalGrouping, '').replace(decimalSymbol, '.'));
                    if(floatValue == 0 && e.keyCode == 8)
                        $(this).val("");
                });
            }

        };

        this.render = function () {

            this.createElement();
            this.addEventListeners();
            this.setInputValue();
            return this.rootEl;

        };

    }

    return MileOrMeters;

}());